// extracted by mini-css-extract-plugin
export default {"main":"Main_main__W-m-+","aside":"Main_aside__KrU-O","article":"Main_article__n7Q8r"};